import { useEffect, useState } from 'react';
import { Outlet } from "react-router";
import Loader from "../components/Loader";

const RequireAuth = () => {
  const [inProgress, setInProgress] = useState('loading');
  const isAuthenticated = true;

  useEffect(() => {
    if (!isAuthenticated) {
      // If not authenticated and not loading, initiate login process
      
    }
    setInProgress("none");
  }, [isAuthenticated]);

  if (inProgress !== "none") return <Loader />;

  return isAuthenticated ? <Outlet /> : <Loader />;
};

export default RequireAuth;
